var map = {
	"./auditLog.json": "VtY8",
	"./backup.json": "7ZDH",
	"./blogCategory.json": "1Z8w",
	"./blogPost.json": "Piuv",
	"./caseStudy.json": "N61T",
	"./common.json": "RUMV",
	"./configuration.json": "kEFh",
	"./contact.json": "qJzs",
	"./crud.json": "GwX5",
	"./dashboard.json": "KG4b",
	"./faq.json": "A0Jo",
	"./footer.json": "Bz0f",
	"./forgot.json": "5nY4",
	"./header.json": "6wrV",
	"./job.json": "PNxJ",
	"./login.json": "XngJ",
	"./pageConfiguration.json": "0tPw",
	"./payment.json": "VqX5",
	"./pdfTemplate.json": "soL+",
	"./permission.json": "2jNJ",
	"./portfolio.json": "sC31",
	"./portfolioCategory.json": "3muf",
	"./product.json": "5zU4",
	"./resetPassword.json": "h4xQ",
	"./role.json": "5fHP",
	"./sample.json": "jlXd",
	"./service.json": "KINV",
	"./sider.json": "smyv",
	"./signUp.json": "y4oA",
	"./sms.json": "kmus",
	"./staticPage.json": "oHBx",
	"./support.json": "oFut",
	"./systemPage.json": "qiGN",
	"./technology.json": "JZY5",
	"./template.json": "7feM",
	"./testimonial.json": "f3ns",
	"./theme.json": "Wy44",
	"./user.json": "f+qO",
	"./verification.json": "iBY1"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "XeCg";